<template>
  <a-select
      show-search
      placeholder="请选择门店"
      option-filter-prop="children"
      style="width: 155px"
      size="large"
      :filter-option="false"
      :getPopupContainer="trigger => trigger.parentNode"
      @popupScroll="goodsScroll"
      @search="fetchRestaurant"
      @change="chooseOption"
      :value="currentValue.label?currentValue:undefined"
      label-in-value>
    <a-select-option v-for="(item,index) in restaurantList" :key="index" :value="item.id">
      {{item.name}}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "restaurantSelector",
  props:{
   currentValue:{
      type:Object,
    }
  },
  data(){
    return{
      restaurantList: [],
      queryParam:{
        current:1,
        size:20,
        name:'',
      },
      selectOption:'',
      text:'',
    }
  },
  created() {
    this.getRestaurantDropDownList(this.queryParam);
  },
  methods:{
    chooseOption(value){
      this.$emit('restaurantSelectChange',value);
    },
    fetchRestaurant(value){
      const params = {
        current:1,
        size:this.queryParam.size,
        name:value,
      }
      this.getRestaurantDropDownList(params);
    },
    goodsScroll(e){
      const { target } = e;
      if(target.scrollTop+target.offsetHeight===target.scrollHeight){
        const nextIndex = this.queryParam.current+1;
        this.setIndex(nextIndex);
        this.getRestaurantDropDownList(this.queryParam)
      }
    },
    setIndex(index){
      this.queryParam.current = index;
    },
    getRestaurantDropDownList(params){
      const userType = this.$store.getters.userInfo.staffType;
      if(userType===0){
        this.$api.restaurant.restaurantDropDownList(params).then(res => {
          if (res.code === 200 && res.success) {
            this.restaurantList = res.data.records;
          }
        });
      }
      if(userType===1){
        this.$api.supplier.supplierBindResDropDownList(params).then(res => {
          if (res.code === 200 && res.success) {
            this.restaurantList = res.data.records;
          }
        });
      }
    },
  },
  watch:{
    currentValue(val){
      this.text = val.label;
    }
  }
}
</script>

<style scoped>

</style>